import { render, staticRenderFns } from "./courseItemResource.vue?vue&type=template&id=5c6887e8&scoped=true"
import script from "./courseItemResource.vue?vue&type=script&lang=js"
export * from "./courseItemResource.vue?vue&type=script&lang=js"
import style0 from "./courseItemResource.vue?vue&type=style&index=0&id=5c6887e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6887e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6887e8')) {
      api.createRecord('5c6887e8', component.options)
    } else {
      api.reload('5c6887e8', component.options)
    }
    module.hot.accept("./courseItemResource.vue?vue&type=template&id=5c6887e8&scoped=true", function () {
      api.rerender('5c6887e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/courseItemResource.vue"
export default component.exports